// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__ryyK9","footer":"ModalUpdate_footer__a-DZ5"};